import CreateSmartTipView from './CreateSmartTip';

export default CreateSmartTipView;
